<template>
    <div>
        <headline>
            Meldungen
        </headline>

        <loading v-show="loading"></loading>

        <warning> Die von den Mitarbeitenden als "fehlerhaft" gemeldeten Schreibtische werden nach einem Tag automatisch wieder zur Vermittlung gestellt. Sollte das Problem bereits vorher gelöst worden sein, kann der Schreibtisch für den heutigen Tag manuell wieder frei gegeben werden. </warning>

        <h3 class="text-2xl leading-6 font-medium text-gray-900 mt-8"> Meldungen vom heutigen Tag </h3>

        <div class="mx-4 flex justify-center mt-6" v-show="errorsToday.length === 0">
            <p>Heute wurden keine Fehler gemeldet</p>
        </div>
            <tailwind-table :header="['Datum', 'Schreibtisch', 'Meldung', 'Gemeldet von', '']" class="w-full mt-6" v-show="errorsToday.length !== 0">
                <tr v-for="(error, i) in errorsToday" :class="{'bg-gray-50': i % 2}">
                    <td class="px-6 py-3">
                        {{ error.day }}
                    </td>
                    <td class="px-6 py-3">
                        <span v-if="error.desk">
                            {{ error.desk.name }}
                        </span>
                        <span v-show="!error.desk">
                            Gelöschter Schreibtisch
                        </span>
                    </td>
                    <td class="px-6 py-3">
                        {{ error.note }}
                    </td>
                    <td class="px-6 py-3">
                        <span v-if="error.user">
                            {{ error.user.first_name }} {{ error.user.name }}
                        </span>
                        <span v-show="!error.user">
                            Gelöschter User
                        </span>
                    </td>
                    <td class="px-6 py-3">
                        <error-message-delete :error=error @reload="load()"></error-message-delete>
                    </td>
                </tr>
            </tailwind-table>

        <div v-show="!loading">
            <h3 class="text-2xl leading-6 font-medium text-gray-900 mt-12"> Meldungen älter als ein Tag </h3>
            <div class="mt-6" v-show="!loading">
                <tailwind-table :header="['Datum', 'Schreibtisch', 'Meldung', 'Gemeldet von']">
                    <tr v-for="(error, i) in errors" :class="{'bg-gray-50': i % 2}">
                        <td class="px-6 py-3">
                            {{ error.day }}
                        </td>
                        <td class="px-6 py-3">
                            <span v-if="error.desk">
                                {{ error.desk.name }}
                            </span>
                            <span v-show="!error.desk">
                                Gelöschter Schreibtisch
                            </span>
                        </td>
                        <td class="px-6 py-3">
                            {{ error.note }}
                        </td>
                        <td class="px-6 py-3">
                            <span v-if="error.user">
                                {{ error.user.first_name }} {{ error.user.name }}
                            </span>
                            <span v-if="!error.user">
                                Gelöschter User
                            </span>
                        </td>
                    </tr>
                </tailwind-table>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading";
import TailwindTable from "../components/UI/TailwindTable";
import Headline from "../components/UI/Headline";
import Warning from "../components/UI/Warning";
import ErrorMessageDelete from "../components/ErrorMessageDelete";

export default {
    name: "ErrorMessages",
    components: {TailwindTable, Loading, Headline, ErrorMessageDelete, Warning},

    inject: ['group'],

    data: () => ({
        loading: false,
        errors: [],
        errorsToday: [],
    }),

    created() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            window.axios.get('/admin/error_messages')
                .then(result => {
                    this.loading = false;
                    this.errors = result.data.data;
                    this.errorsToday = result.data.today;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
